import { render, staticRenderFns } from "./VacationPlanner.vue?vue&type=template&id=2972cfe2&scoped=true&"
import script from "./VacationPlanner.vue?vue&type=script&lang=ts&"
export * from "./VacationPlanner.vue?vue&type=script&lang=ts&"
import style0 from "./VacationPlanner.vue?vue&type=style&index=0&id=2972cfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972cfe2",
  null
  
)

export default component.exports